
ko.bindingHandlers.chart = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        ko.bindingHandlers.chart.update(element, valueAccessor);

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            var chart = ko.utils.domData.get(element, 'chart');

            if (chart) {
                chart.destroy();
            }
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, context) {
        var options = ko.unwrap(valueAccessor());
        var chart = ko.utils.domData.get(element, 'chart');

        if (chart) {
            chart.destroy();
            chart = null;
        }

        if (options && options.chart && !chart) {
            chart = new ApexCharts(
                element,
                options
            );

            ko.utils.domData.set(element, 'chart', chart);
        }

        if (chart) {
            chart.render();
        }
    }
};